<button type="button" class="btn btn-primary" matTooltip="{{ 'preview' | translate }}" [disabled]="isDisabled || (isInProgress$ | async)">
  <button-icon-loader [isLoading]="isInProgress$ | async" [defaultIcon]="['fas', 'file-pdf']"></button-icon-loader>
  <span class="ml-1">{{ 'preview' | translate }}</span>
</button>
